export const courses = {
  "equity-research": {
    id: "equity-research",
    title: "Equity Research & Financial Modeling",
    duration: "5 weeks",
    price: 1999,
    format: "6 live weekend sessions + 3-week project",
    description:
      "Master equity research through hands-on financial modeling with industry experts.",
    features: [
      "3-statement financial modeling",
      "DCF and relative valuation",
      "Live mentorship from analysts",
      "Work experience certificate",
      "Letter of recommendation",
      "Interview preparation",
    ],
    outcomes: [
      "Build 3-statement linked models",
      "Perform DCF valuation",
      "Write investment thesis reports",
      "Model companies like professionals",
    ],
  },

  "fixed-income": {
    id: "fixed-income",
    title: "Fixed Income & Credit Analysis",
    duration: "1 month",
    price: 2999,
    format: "4 live weekend sessions + 3-week project",
    description:
      "Deep-dive into bond valuation and credit risk assessment.",
    features: [
      "Bond valuation models",
      "Credit risk metrics (LGD, PD, CVA)",
      "Altman Z-Score modeling",
      "Live expert sessions",
      "Work experience certificate",
      "Letter of recommendation",
    ],
    outcomes: [
      "Analyze bonds professionally",
      "Compute duration & convexity",
      "Evaluate creditworthiness",
      "Perform portfolio sensitivity analysis",
    ],
  },

  "quantitative-finance": {
    id: "quantitative-finance",
    title: "Quantitative Finance",
    duration: "5 weeks",
    price: 2999,
    format: "6 Python-focused sessions + 2-week project",
    description:
      "Learn Python for portfolio optimization and risk management.",
    features: [
      "Python for finance (pandas, numpy)",
      "Portfolio optimization techniques",
      "Monte Carlo simulation",
      "Value at Risk (VaR) implementation",
      "Work experience certificate",
      "Letter of recommendation",
    ],
    outcomes: [
      "Use Python for financial modeling",
      "Optimize portfolios",
      "Build risk simulation models",
      "Backtest quant strategies",
    ],
  },
};
